import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import cn from 'classnames';
import { FMessage } from '../../hoc/IntlComponents';

const ContractsFormControls = ({ types, active, handleTypeChange }) => {
  return (
    <Row className="contracts-controls">
      <Col sm="12" md="12" className="contracts-notify">
        <b>
          <FMessage id="contracts.notify-text.nesessary" />
        </b>
      </Col>
      <Col sm="12" md="12">
        <ul className="section-contract-controls">
          {types.map((key, index) => (
            <li key={key} className="list-contract-controls">
              <button
                className={cn('list-contract-btn', {
                  'list-contract-btn-current': index === active,
                })}
                type="button"
                onClick={() => index !== active && handleTypeChange(index)}
              >
                <FMessage id={`contracts.controls.${key}`} />
              </button>
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
};

export default ContractsFormControls;
